import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  children: React.ReactNode
  className?: string
}

HeadlineThree.defaultProps = {
  className: '',
}

function HeadlineThree(props: Props) {
  const { className, children } = props
  return <h3 className={classNames(style.wrapper, className)}>{children}</h3>
}

export default HeadlineThree
